export default "__VITE_ASSET__BFibRLog__"